import { motion } from "motion/react";
import { ReactNode, useEffect, useRef } from "react";
import { useLocation } from "@tanstack/react-router";
import { useGamification } from "./GamificationProvider";

interface PageTransitionProps {
  children: ReactNode;
}

export function PageTransition({ children }: PageTransitionProps) {
  const location = useLocation();
  const { visitPage } = useGamification();
  const previousPath = useRef(location.pathname);

  useEffect(() => {
    // Only visit if path actually changed
    if (previousPath.current !== location.pathname) {
      visitPage(location.pathname);
      previousPath.current = location.pathname;
    }
  }, [location.pathname]); // Only depend on pathname, not visitPage

  return (
    <motion.div
      key={location.pathname}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{
        duration: 0.3,
        ease: [0.22, 1, 0.36, 1]
      }}
    >
      {children}
    </motion.div>
  );
}